export default "skymp5-front/a8819417669964685168bb2be41a83ba.mp3";